import React, { useEffect } from "react";
import styles from "./Loader.module.scss";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import logo from "../../../assets/images/logo.svg";

const Loader = () => {
    const { loading } = useSelector((state) => state.loading);
    useEffect(() => {
        if (loading) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [loading]);

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                newestOnTop
                limit={1}
                closeOnClick
                pauseOnHover
                draggable
            />
            {loading ? (
                <span className={styles.loader}>
                    <img src={logo} alt="white-logo" />
                </span>
            ) : null}
        </>
    );
};

export default Loader;
